import { PredictionLabelType } from '@modules/feedback/types';
import { FeedbackLabelType } from 'v2/core/entities/feedback';

export const getLabelTypeFromPredictionType = (
  predictionType: PredictionLabelType,
) => {
  switch (predictionType) {
    case PredictionLabelType.Entity:
      return FeedbackLabelType.Entity;
    case PredictionLabelType.Search:
      return FeedbackLabelType.Search;
    case PredictionLabelType.Reason:
      return FeedbackLabelType.Reason;
    case PredictionLabelType.Sentiment:
      return FeedbackLabelType.Sentiment;
    default:
      return predictionType;
  }
};
